var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5,
    r: 19.5,
    fill: "white",
    stroke: "#E4E4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9062 28.625H14.0938C13.6016 28.625 13.25 28.2734 13.25 27.7812C13.25 27.3242 13.6016 26.9375 14.0938 26.9375H25.9062C26.3633 26.9375 26.75 27.3242 26.75 27.7812C26.75 28.2734 26.3633 28.625 25.9062 28.625ZM19.3672 23.8789L14.8672 19.0977C14.5508 18.7461 14.5859 18.2188 14.9023 17.9023C15.2539 17.5859 15.7812 17.5859 16.0977 17.9375L19.1562 21.1719V18.2188V13.7188C19.1562 13.2617 19.5078 12.875 20 12.875C20.457 12.875 20.8438 13.2617 20.8438 13.7188V18.2188V21.1719L23.8672 17.9375C24.1836 17.5859 24.7109 17.5859 25.0625 17.9023C25.4141 18.2188 25.4141 18.7461 25.0977 19.0977L20.5977 23.8789C20.4219 24.0547 20.2109 24.125 20 24.125C19.7539 24.125 19.543 24.0547 19.3672 23.8789Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportDownloadIcon);
export default __webpack_public_path__ + "static/media/report_download_icon.efe24f0e1866dc73637f6aa546e97941.svg";
export { ForwardRef as ReactComponent };